module.exports = __webpack_public_path__ + "d36af42cfb371c779931a7bc9476b9f1.pdf";